import { StateContext } from "@ngxs/store";

import { IStateProcessor } from "../state-processor";
import { AppDataStateModel } from "@shared/models/app-data.model";
import { NgxsStoreHelpers } from "@shared/stores/store.helpers";
import { CommonSearchCriteria } from "@shared/models/common-data.model";
import { DefaultAwardModel } from "@app/shared/models/award.model";

export class AwardStateProcessor implements IStateProcessor {
  GetDefaultSearchCriteria() {
    return DefaultAwardModel.search.searchForm.model.searchCriteria;
  }

  SetSearchCriteria(ctx: StateContext<AppDataStateModel>, searchCriteria: CommonSearchCriteria[]) {
    NgxsStoreHelpers.SetAwardSearchCriteria(ctx, searchCriteria);
  }

  AttachSearchCriteriaIntoCurrent(ctx: StateContext<AppDataStateModel>, newSearchCriteria: CommonSearchCriteria[]) {
    var currentSearchCriteria = ctx.getState().award.search.searchForm.model.searchCriteria;
    this.SetSearchCriteria(ctx, [...newSearchCriteria, ...currentSearchCriteria]);
  }
}
